import React, { useState } from 'react';

import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';

import { CardContentCaps } from './CardContentCaps';
import { CardContentContent } from './CardContentContent';
import CardContentContext from './CardContentContext';
import { CardContentCta } from './CardContentCta';
import { CardContentLogo } from './CardContentLogo';
import { CardContentTags } from './CardContentTags';
import { CardContentTitle } from './CardContentTitle';
import { CardType, useApplyCardContentWithoutTagStyle } from './logic';
import { CardContentSubtitle } from './CardContentSubtitle';
import { CardContentImage } from './CardContentImage';

export interface CardContentComponentProps extends DefaultBsComponent {
  cardType: CardType;
  hasSubtitleHover?: boolean;
  isHovered?: boolean;
  displaySubtitleOnSmallDevice?: boolean;
}

const Content = ({ children }: any) => {
  const cardContentWithoutTagStyle = useApplyCardContentWithoutTagStyle();

  return (
    <div
      className={classNames(
        'flex flex-col h-full justify-between',
        cardContentWithoutTagStyle
      )}
    >
      {children}
    </div>
  );
};

export const CardContentComponent = ({
  cardType,
  children,
  hasSubtitleHover,
  className,
  isHovered,
  displaySubtitleOnSmallDevice,
  as: Component = 'div',
  ...props
}: CardContentComponentProps) => {
  const [hasTags, setHasTags] = useState(false);
  const [hasLogo, setHasLogo] = useState(false);

  return (
    <CardContentContext.Provider
      value={{
        cardType,
        hasTags,
        setHasTags,
        hasSubtitleHover,
        isHovered,
        hasLogo,
        setHasLogo,
        displaySubtitleOnSmallDevice,
      }}
    >
      <Component
        className={classNames('CardContent', className, 'relative h-full')}
        {...props}
      >
        <Content>{children}</Content>
      </Component>
    </CardContentContext.Provider>
  );
};

export const CardContent = Object.assign(CardContentComponent, {
  Content: CardContentContent,
  Title: CardContentTitle,
  Subtitle: CardContentSubtitle,
  Tags: CardContentTags,
  Logo: CardContentLogo,
  Image: CardContentImage,
  Cta: CardContentCta,
  Caps: CardContentCaps,
});
